import React from 'react';
import { Redirect } from 'react-router-dom';

export default function LoginErrorContainer(props) {
	console.warn(`${props.error}`);
	return <Redirect to="/" />;
}
